export const DEFAULT_BASE_CUSTOM_FRAME = {
    scale: 100, x: 0, y: 0, thickness: 28, radius: 72,
    fill: 'solid', color: '#ffffff', color2: '#9abcf8', angle: 135,
    opacity: 100, glass: false, blur: 18, refraction: 45, backgroundBlur: 0
};
const finite = (value, fallback, min, max) => typeof value === 'number' && Number.isFinite(value) ? Math.max(min, Math.min(max, value)) : fallback;
const color = (value, fallback) => typeof value === 'string' && /^#[\da-f]{6}$/i.test(value) ? value : fallback;
export function normalizeBaseCustomFrame(value) {
    const v = value || {}, d = DEFAULT_BASE_CUSTOM_FRAME;
    return {
        scale: finite(v.scale, d.scale, 10, 180), x: finite(v.x, d.x, -50, 50), y: finite(v.y, d.y, -50, 50),
        thickness: finite(v.thickness, d.thickness, 0, 180), radius: finite(v.radius, d.radius, 0, 480),
        fill: v.fill === 'gradient' ? 'gradient' : 'solid', color: color(v.color, d.color), color2: color(v.color2, d.color2),
        angle: finite(v.angle, d.angle, 0, 360), opacity: finite(v.opacity, d.opacity, 0, 100),
        glass: v.glass === true, blur: finite(v.blur, d.blur, 0, 60), refraction: finite(v.refraction, d.refraction, 0, 100),
        backgroundBlur: finite(v.backgroundBlur, d.backgroundBlur, 0, 100)
    };
}
